import styled from 'styled-components';

export const ErrorMessage = styled.div`
	p {
		text-align: center;
	}
`;
